import { Checkbox } from 'slab'

interface DifferentCarriersFilterProps {
  differentCarriersOnly: boolean
  onToggle: () => void
}

export function DifferentCarriersFilter ({ differentCarriersOnly, onToggle }: DifferentCarriersFilterProps) {
  return (
    <Checkbox
      checked={differentCarriersOnly}
      onChange={onToggle}
      label='Different carriers only'
    />
  )
}
